import type {
  MediaEdge,
  MediaImage,
} from '@shopify/hydrogen-react/storefront-api-types'

/**
 * Shopify `Product` `MediaImage` typeguard.
 *
 */
export const isMediaImage = (media: MediaEdge['node']): media is MediaImage => {
  return media.__typename === 'MediaImage'
}
